import React from "react";
import { FormattedMessage } from "react-intl";
import CustomChip from "../../general/chips";

const CategoriesFilters = ({categories, activeFilter, filterCategories}) => {
  const categoriesIds = [...categories];
  return (
    categoriesIds.map((category, index) => {
      return <CustomChip
        key={index}
        className="askEdit-customChip"
        active={activeFilter === category}
        onClick={() =>
          filterCategories(category)}
        description={<FormattedMessage id={category !== "Tutti" ? `ask.categories.${category}` : "ask.categories.all" } />}
      />;
    }));
};

export default CategoriesFilters;